// The offer calculator: a short quiz that ends in a finished offer with PDF, link and QR code.
// Prices, products and settings come from the section (sections/angebot.liquid); the calculating is done by
// assets/angebot-core.js. The questions and their wording live in AUDIENCES, DESIGNS and the screen functions
// below: add a question by adding a screen to `flow()` and a function to SCREENS.
(() => {
  'use strict';

  const O = window.MixedownOffer;
  const Reel = window.MixedownOfferReel;
  const root = document.querySelector('[data-offer]');
  const source = document.querySelector('[data-offer-config]');
  if (!O || !Reel || !root || !source) return;
  const { ICONS, escapeHtml, money, taxSuffix, WEEKDAYS, pieces, firstColor, extraTag, EXPRESS_TAG } = Reel;

  let config;
  try {
    config = O.normalizeConfig(JSON.parse(source.textContent));
  } catch (error) {
    console.error('Angebotsrechner: Einstellungen nicht lesbar', error);
    return;
  }

  const STORAGE_KEY = 'mixedown-angebot';
  const SENT_KEY = 'mixedown-angebot-sent';
  const stage = root.querySelector('[data-offer-stage]');
  const dock = root.querySelector('[data-offer-dock]');
  const live = root.querySelector('[data-offer-live]');
  const nextButton = root.querySelector('[data-offer-next]');
  const nextLabel = root.querySelector('[data-offer-next-label]');
  const backButton = root.querySelector('[data-offer-back]');
  const startButton = root.querySelector('[data-offer-start]');
  const startLabel = startButton.querySelector('[data-offer-start-label]');
  const startText = startLabel.textContent;
  const progress = root.querySelector('[data-offer-progress]');
  const toastBox = root.querySelector('[data-offer-toast]');
  const form = document.querySelector('[data-offer-form]');
  const intro = stage.querySelector('[data-offer-intro]');

  // ---------------------------------------------------------------------------------------------------------------
  // Wording. Who the merch is for steers the recommendations, the questions and the invoice details.

  const AUDIENCES = [
    { key: 'team', title: 'Team & Verein', text: 'Sport, Ehrenamt und Fanclub', type: 'club', ask: 'Was soll euer Team tragen?' },
    { key: 'company', title: 'Firma & Startup', text: 'Teamwear, Merch und Giveaways', type: 'business', ask: 'Was braucht euer Team?' },
    { key: 'artist', title: 'Band, Artist & Creator', text: 'Merch für Fans, Tour und Shop', type: 'business', ask: 'Was kommt an den Merchstand?' },
    { key: 'event', title: 'Event & Agentur', text: 'Festivals, Messen und Kundenevents', type: 'business', ask: 'Was tragt ihr auf dem Event?' },
    { key: 'school', title: 'Schule & Uni', text: 'Abschluss, Klasse und Fachschaft', type: 'club', ask: 'Was tragt ihr gemeinsam?' },
    { key: 'trade', title: 'Gastro, Handwerk & Handel', text: 'Workwear und Merch zum Verkaufen', type: 'business', ask: 'Was braucht euer Betrieb?' }
  ];
  const audienceOf = key => AUDIENCES.find(entry => entry.key === key) || AUDIENCES.find(entry => entry.key === 'company');

  // A pixel picture for each audience: 16 × 16 cells, one character per cell, '.' stays empty.
  const PIXEL_COLORS = { '#': 'var(--offer-ink)', '-': 'var(--offer-paper)', o: 'var(--offer-orange)', b: 'var(--offer-blue)', g: 'var(--offer-green)' };
  const PIXELS = {
    team: [
      '..############..',
      '####oooooooo####',
      '#..#ooo--ooo#..#',
      '#..#o------o#..#',
      '#..#oo----oo#..#',
      '.#.#o--oo--o#.#.',
      '..##oooooooo##..',
      '....#oooooo#....',
      '.....#oooo#.....',
      '......#oo#......',
      '......#oo#......',
      '.....######.....',
      '....#oooooo#....',
      '....#oooooo#....',
      '...##########...'
    ],
    company: [
      '.......##.......',
      '......#oo#......',
      '.....#oooo#.....',
      '.....#----#.....',
      '....#------#....',
      '....#--##--#....',
      '....#-#bb#-#....',
      '....#-#bb#-#....',
      '....#--##--#....',
      '....#------#....',
      '...##------##...',
      '..#o#------#o#..',
      '.#oo#------#oo#.',
      '.###.######.###.',
      '......oooo......',
      '.......oo.......'
    ],
    artist: [
      '................',
      '......#########.',
      '......#########.',
      '......##.....##.',
      '......##.....##.',
      '......##.....##.',
      '......##.....##.',
      '......##.....##.',
      '......##.....##.',
      '......##.....##.',
      '...#####..#####.',
      '..#bb-##.#bb-##.',
      '..#bbbb#.#bbbb#.',
      '...####...####..',
      '................',
      '................'
    ],
    event: [
      '.......##ooo....',
      '.......##ooooo..',
      '.......##ooo....',
      '.......##.......',
      '......#--#......',
      '.....#g--g#.....',
      '....#gg--gg#....',
      '...#ggg--ggg#...',
      '..#gggg--gggg#..',
      '.#ggggg--ggggg#.',
      '################',
      '.#g-g-####-g-g#.',
      '.#g-g-#..#-g-g#.',
      '.#g-g-#..#-g-g#.',
      '.#g-g-#..#-g-g#.',
      '.##############.'
    ],
    school: [
      '.......##.......',
      '....###oo###....',
      '.#######oooooo#.',
      '...##########.o.',
      '.....######...o.',
      '....#------#..o.',
      '....#-######.ooo',
      '.....######..ooo',
      '................',
      '..############..',
      '.#bbbbbbbbbbbb#.',
      '.#b-bbbbbbbbbb#.',
      '.#------------#.',
      '.#------------#.',
      '.##############.',
      '................'
    ],
    trade: [
      '................',
      '.##############.',
      '.#------------#.',
      '.#-###-##-###-#.',
      '.#------------#.',
      '################',
      '#oo--oo--oo--oo#',
      '#oo--oo--oo--oo#',
      '.##.##.##.##.##.',
      '.#------------#.',
      '.#-####--####-#.',
      '.#-#bb#--#oo#-#.',
      '.#-#b-#--#oo#-#.',
      '.#-####--#o-#-#.',
      '.#-------#oo#-#.',
      '################'
    ]
  };
  const pixelIcon = rows => {
    const top = Math.floor((16 - rows.length) / 2);
    const paths = {};
    rows.forEach((row, y) => {
      for (let x = 0, n; x < row.length; x += n) {
        for (n = 1; row[x + n] === row[x]; n++);
        if (PIXEL_COLORS[row[x]]) paths[row[x]] = `${paths[row[x]] || ''}M${x} ${y + top}h${n}v1h-${n}z`;
      }
    });
    return `<svg viewBox="0 0 16 16" shape-rendering="crispEdges" aria-hidden="true" focusable="false">${Object.entries(paths).map(([cell, d]) => `<path style="fill: ${PIXEL_COLORS[cell]}" d="${d}"/>`).join('')}</svg>`;
  };

  const DESIGNS = [
    { key: 'ready', title: 'Ja, druckfertig', text: 'Logo oder Motiv in hoher Auflösung. Jede Datei prüfen wir (echte Menschen) kostenlos.' },
    { key: 'adjust', title: 'Ja, aber nicht druckfertig', text: 'Zum Beispiel ein Logo als Screenshot. Wir bereiten es sauber für den Druck auf.', fee: 'adjust' },
    { key: 'service', title: 'Nein, gestaltet ihr es', text: 'Du beschreibst deine Idee, unser Team gestaltet das Motiv für dich.', fee: 'service' },
    { key: 'studio', title: 'Ich gestalte selbst', text: 'Im Studio mit Effekten. Die Daten schickst du uns danach.', side: 'Inklusive' }
  ];

  // Swatch colors by name, from the configurator's catalog; Shopify swatches win where they are set.
  const COLORS = {
    'weiß': '#f4f4f2', schwarz: '#1b1b1d', 'sport grau': '#b8b8b6', navy: '#1f2a44', olive: '#5b5e3c', hellrot: '#d33a36', gelb: '#f2cf3d', rosa: '#f2b8c6',
    'grau meliert': '#b3afb0', 'mountain blue': '#0a416b', 'college green': '#00704f', 'desert sand': '#f0d7c6', 'dark grey': '#2d3538', 'pacific grey': '#bbbcbe',
    'royal blue': '#144e8e', 'lotus blue': '#a2c6e8', red: '#c2171f', 'melon orange': '#f5a870', 'lotus pink': '#ec699d', burgundy: '#5d2936', 'pop tomato': '#f41a1c',
    'acid lime': '#c3d22d', 'camo green': '#5e5f4f', 'dark forest': '#0b2a22', 'pop turquoise': '#009099', 'pop green': '#00a56d', 'pop yellow': '#fab900',
    'roasted coffee': '#45352f', mastic: '#c3b297', rot: '#cb1430', natur: '#e6e2d7', 'dusty blue': '#cadee7', 'powder pink': '#f5e0e5', fuchsia: '#c90075',
    'schwarz/dunkelgrau': '#3c3634', 'waldgrün/grau': '#224238', sonnengelb: '#fcbd2a', violett: '#826eb5', kornblumenblau: '#2261ae', orange: '#d6642e',
    himbeerpink: '#f05577', 'apfelgrün': '#93b53a', 'vintage leopard': '#aa8b67', grau: '#6b6e75', royal: '#24307a'
  };

  // ---------------------------------------------------------------------------------------------------------------
  // State.

  const blankContact = () => ({ name: '', org: '', email: '', phone: '', message: '' });
  const fresh = () => ({
    v: 1,
    step: 'who',
    ...Reel.blankOrder(config),
    contact: blankContact(),
    number: '',
    created: '',
    total: null
  });

  let state = fresh();
  let current = 'intro';
  let opened = null; // what a shared link said when it was opened: { number, total, expired }

  const save = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...state, saved: Date.now(), intro: current === 'intro' }));
    } catch {}
  };

  // Whether the saved visit was inside the calculator rather than on the intro.
  const draftInFlow = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)).intro === false;
    } catch {
      return false;
    }
  };

  const load = () => {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!data || data.v !== 1 || Date.now() - (data.saved || 0) > 60 * 864e5) return null;
      const restored = { ...fresh(), ...data, contact: { ...blankContact(), ...(data.contact || {}) } };
      delete restored.saved;
      delete restored.intro;
      restored.selected = (restored.selected || []).filter(id => O.productOf(config, id));
      restored.lines = (restored.lines || []).filter(line => restored.selected.includes(line.product) && O.productOf(config, line.product).colors.some(color => color.name === line.color));
      restored.extras = (restored.extras || []).filter(id => config.extras.some(extra => extra.id === id));
      restored.country = config.home;
      restored.vatId = '';
      return restored;
    } catch {
      return null;
    }
  };

  // Every change to what is offered goes through here: the offer number belongs to one exact offer.
  const change = mutate => {
    mutate(state);
    state.number = '';
    state.created = '';
    save();
    refresh();
  };

  const quoteNow = () => O.quote(config, state);
  const isBusiness = () => audienceOf(state.who).type === 'business';

  // Short, next to a net amount: the VAT that comes on top, or why there is none.
  const taxNote = q => (q.tax.note ? taxSuffix(q, true) : `zzgl. ${O.formatPercent(q.tax.rate)} USt.`);
  const tooMany = () => `Pro Angebot gehen maximal ${O.formatCount(config.maxPieces)} Teile. Für größere Mengen schreib uns gern direkt.`;
  // Plain text: an estimate split over the sizes, as the core plans it.
  const spreadText = (total, sizes) => Object.entries(O.distribute(total, sizes)).map(([size, n]) => `${n}x ${size}`).join(' / ') || 'Wir planen mit einer typischen Größenverteilung.';

  // A configured German final price as the customer is shown it: net.
  const shown = homeGross => Math.round(homeGross / (1 + config.vat / 100));

  const swatchOf = color => {
    const value = String(color.swatch || '').trim();
    if (value && window.CSS && CSS.supports && CSS.supports('color', value)) return value;
    return COLORS[String(color.name).toLowerCase()] || '#c8c8c8';
  };

  const imageOf = (product, colorName) => {
    const color = product.colors.find(entry => entry.name === colorName);
    return (color && color.image) || product.image || '';
  };


  const productPieces = id => state.lines.filter(line => line.product === id).reduce((sum, line) => sum + O.countOf(O.productOf(config, line.product), line), 0);
  const fromPrice = product => shown(Math.min(...product.variants.filter(variant => variant[4] !== 0).map(variant => variant[2])));
  // A position that costs nothing, such as the shop, says so instead of 0,00 €.
  const priced = cents => (cents ? money(cents) : 'Inklusive');
  const extraPrice = extra => (extra.price ? `+ ${money(shown(extra.price))}${extra.unit === 'piece' ? ' / Teil' : ''}` : `${extra.was ? `<s>${escapeHtml(extra.was)}</s> ` : ''}Inklusive`);
  // Working days from today until the order arrives, proof included.
  const totalDays = q => q.delivery.standardApproval + q.delivery.standardDays;
  const expressText = q => `Ca. ${q.delivery.expressApproval + q.delivery.expressDays} statt ${totalDays(q)} Werktage bis zur Lieferung`;
  const expressSaving = q => {
    const days = totalDays(q) - (q.delivery.expressApproval + q.delivery.expressDays);
    return `Du sparst ca. ${days} ${days === 1 ? 'Werktag' : 'Werktage'} bis zur Lieferung.`;
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Flow. The screens in order; one per chosen product to pick colors and sizes.

  const flow = () => [
    'who',
    'products',
    ...state.selected.map(id => `configure:${id}`),
    'design',
    ...(config.extras.length ? ['extras'] : []),
    'timing',
    'contact',
    'offer'
  ];

  const toast = message => {
    toastBox.textContent = message;
    toastBox.classList.add('is-visible');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => toastBox.classList.remove('is-visible'), 2600);
  };

  const shake = element => {
    if (!element) return;
    element.classList.remove('mxd-offer__shake');
    void element.offsetWidth;
    element.classList.add('mxd-offer__shake');
  };

  // Plays the picked animation once, every time the choice is switched on.
  const light = element => {
    element.classList.remove('is-lit');
    void element.offsetWidth;
    element.classList.add('is-lit');
    element.addEventListener('animationend', event => {
      if (event.target === element) element.classList.remove('is-lit');
    }, { once: true });
  };

  // A burst of confetti from where a free extra is switched on, or from the middle when an accepted offer went out,
  // drawn on one canvas at the screen's frame rate: the pieces shoot up, tumble and flutter down while the air slows
  // them, then fade out.
  const CONFETTI_COLORS = ['--offer-green', '--offer-yellow', '--offer-blue', '--offer-orange', '--offer-ink'];
  const confetti = (element, event) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const box = element.getBoundingClientRect();
    const x = event && event.detail ? event.clientX : box.left + box.width / 2;
    const y = event && event.detail ? event.clientY : box.top + box.height / 2;
    const style = window.getComputedStyle(root);
    const colors = CONFETTI_COLORS.map(name => style.getPropertyValue(name).trim());
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    const canvas = document.createElement('canvas');
    canvas.className = 'mxd-offer__confetti';
    canvas.width = Math.round(window.innerWidth * ratio);
    canvas.height = Math.round(window.innerHeight * ratio);
    root.append(canvas);
    const context = canvas.getContext('2d');
    // Speeds are in pixels per 60th of a second, so every frame rate plays the same flight.
    const bits = Array.from({ length: 80 }, (_, index) => {
      const angle = (-90 + (Math.random() - 0.5) * 120) * Math.PI / 180;
      const speed = 10 + Math.random() * 10;
      return {
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        width: 6 + Math.random() * 4,
        round: index % 4 === 0,
        color: colors[index % colors.length],
        spin: Math.random() * Math.PI * 2,
        turn: (Math.random() - 0.5) * 0.3,
        flip: Math.random() * Math.PI * 2,
        flutter: 0.08 + Math.random() * 0.12,
        age: 0,
        life: 80 + Math.random() * 50
      };
    });
    let last = performance.now();
    const frame = now => {
      const step = Math.min((now - last) / (1000 / 60), 3);
      last = now;
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.clearRect(0, 0, canvas.width, canvas.height);
      let flying = 0;
      for (const piece of bits) {
        piece.age += step;
        if (piece.age >= piece.life) continue;
        flying += 1;
        const air = 0.955 ** step;
        piece.vx *= air;
        piece.vy = piece.vy * air + 0.38 * step;
        piece.flip += piece.flutter * step;
        piece.spin += piece.turn * step;
        piece.x += (piece.vx + Math.sin(piece.flip) * 0.8) * step;
        piece.y += piece.vy * step;
        context.globalAlpha = Math.min(1, (piece.life - piece.age) / 25);
        context.fillStyle = piece.color;
        context.setTransform(ratio, 0, 0, ratio, piece.x * ratio, piece.y * ratio);
        context.rotate(piece.spin);
        context.scale(1, Math.cos(piece.flip));
        if (piece.round) {
          context.beginPath();
          context.arc(0, 0, piece.width / 2.4, 0, Math.PI * 2);
          context.fill();
        } else {
          context.fillRect(-piece.width / 2, -piece.width / 3.2, piece.width, piece.width / 1.6);
        }
      }
      if (flying) requestAnimationFrame(frame);
      else canvas.remove();
    };
    requestAnimationFrame(frame);
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Pieces of markup the screens share.

  const head = title => `
    <h2 class="mxd-offer__title" tabindex="-1" data-offer-title>${escapeHtml(title)}</h2>`;

  const hint = (text, tone = '', icon = ICONS.info) => `<div class="mxd-offer__hint${tone ? ` mxd-offer__hint--${tone}` : ''}">${icon}<div>${text}</div></div>`;

  const choice = ({ value, title, text = '', side = '', checked, role = 'radio', tags = '', tone = '', icon = '' }) => `
    <button type="button" class="mxd-offer__choice${tone ? ` mxd-offer__choice--${tone}` : ''}" role="${role}" aria-checked="${checked ? 'true' : 'false'}" data-value="${escapeHtml(value)}">
      <span class="mxd-offer__mark" aria-hidden="true">${ICONS.check}</span>
      <span class="mxd-offer__choice-main">
        <span class="mxd-offer__choice-title">${escapeHtml(title)}${tags ? ` ${tags}` : ''}</span>
        ${text ? `<span class="mxd-offer__choice-text">${escapeHtml(text)}</span>` : ''}
      </span>
      ${side ? `<span class="mxd-offer__choice-side">${side}</span>` : ''}
      ${icon ? `<span class="mxd-offer__choice-icon">${icon}</span>` : ''}
    </button>`;

  const stepper = (key, value, label) => `
    <div class="mxd-offer__stepper${value > 0 ? ' has-value' : ''}" data-stepper="${escapeHtml(key)}">
      <button type="button" data-step="-1" aria-label="${escapeHtml(label)}: eins weniger">${ICONS.minus}</button>
      <input type="number" inputmode="numeric" min="0" max="9999" step="1" value="${value > 0 ? value : ''}" placeholder="0" aria-label="${escapeHtml(label)}">
      <button type="button" data-step="1" aria-label="${escapeHtml(label)}: eins mehr">${ICONS.plus}</button>
    </div>`;

  // ---------------------------------------------------------------------------------------------------------------
  // Screens. Each returns { html, bind(screen), valid() -> true or a message, next?, skip? } for the current state.

  const SCREENS = {};

  SCREENS.who = () => ({
    html: `${head('Für wen?')}
      <div class="mxd-offer__body">
        <div class="mxd-offer__choices mxd-offer__choices--short" role="radiogroup" aria-label="Für wen" style="--offer-columns: 2;">
          ${AUDIENCES.map(entry => choice({ value: entry.key, title: entry.title, text: entry.text, checked: state.who === entry.key, icon: pixelIcon(PIXELS[entry.key]) })).join('')}
        </div>
      </div>`,
    bind: screen => screen.querySelectorAll('[data-value]').forEach(button => button.addEventListener('click', () => {
      change(s => {
        s.who = button.dataset.value;
      });
      paintChoices(screen, [state.who]);
      setTimeout(() => go(1), 220);
    })),
    valid: () => (state.who ? true : 'Wähl kurz aus, für wen das Merch ist.')
  });

  // A product card shows its first colors as dots and counts the rest.
  const CARD_COLORS = 5;

  SCREENS.products = () => {
    const audience = audienceOf(state.who);
    const recommended = product => product.for.includes(state.who);
    // Own goods always come last.
    const products = [...config.products].sort((a, b) => Number(Boolean(a.own)) - Number(Boolean(b.own)) || Number(recommended(b)) - Number(recommended(a)));
    const card = product => {
      const from = fromPrice(product);
      const checked = state.selected.includes(product.id);
      return `
        <button type="button" class="mxd-offer__card" role="checkbox" aria-checked="${checked}" data-value="${escapeHtml(product.id)}">
          <span class="mxd-offer__card-media">
            ${product.image ? `<img src="${escapeHtml(product.image)}" alt="" loading="lazy" width="640" height="640">` : ''}
            ${product.badge ? `<span class="mxd-offer__card-badges"><span class="mxd-offer__tag">${escapeHtml(product.badge)}</span></span>` : ''}
            <span class="mxd-offer__mark" aria-hidden="true">${ICONS.check}</span>
            ${product.colors.length > 1 ? `
              <span class="mxd-offer__card-colors" role="img" aria-label="${product.colors.length} Farben">
                ${product.colors.slice(0, CARD_COLORS).map(color => `<i style="--swatch: ${escapeHtml(swatchOf(color))};"></i>`).join('')}
                ${product.colors.length > CARD_COLORS ? `<b>+${product.colors.length - CARD_COLORS}</b>` : ''}
              </span>` : ''}
          </span>
          <span class="mxd-offer__card-body">
            <span class="mxd-offer__card-title">${escapeHtml(product.title)}</span>
            <span class="mxd-offer__card-price">ab ${money(from)} <span>inkl. Druck</span></span>
          </span>
        </button>`;
    };
    return {
      wide: true,
      html: `${head(audience.ask)}
        <div class="mxd-offer__body">
          <div class="mxd-offer__products" role="group" aria-label="Produkte">${products.map(card).join('')}</div>
        </div>`,
      bind: screen => screen.querySelectorAll('[data-value]').forEach(button => button.addEventListener('click', () => {
        const id = button.dataset.value;
        change(s => {
          if (s.selected.includes(id)) {
            s.selected = s.selected.filter(entry => entry !== id);
            s.lines = s.lines.filter(line => line.product !== id);
          } else {
            s.selected.push(id);
            const product = O.productOf(config, id);
            s.lines.push({ product: id, color: firstColor(product), sizes: {}, total: null });
          }
        });
        button.setAttribute('aria-checked', String(state.selected.includes(id)));
      })),
      valid: () => (state.selected.length ? true : 'Wähl mindestens ein Produkt aus.')
    };
  };

  const configure = id => {
    const product = O.productOf(config, id);
    const lines = () => state.lines.filter(line => line.product === id);
    const specs = [product.info, product.print && `Druckfläche ${product.print}`].filter(Boolean);

    const lineHtml = (line, index) => {
      const sizes = O.sizesFor(product, line.color);
      const count = O.countOf(product, line);
      const estimated = line.total !== null && line.total !== undefined;
      const used = lines().map(entry => entry.color);
      return `
        <div class="mxd-offer__line" data-line="${index}">
          ${product.colors.length > 1 ? `<div class="mxd-offer__line-part">
            <div class="mxd-offer__label">
              <span>Farbe <b>${escapeHtml(line.color)}</b></span>
              ${lines().length > 1 ? '<button type="button" class="mxd-offer__link" data-remove>Entfernen</button>' : ''}
            </div>
            <div class="mxd-offer__swatches" role="radiogroup" aria-label="Farbe">
              ${product.colors.map(color => {
                const available = O.sizesFor(product, color.name).length > 0;
                const taken = color.name !== line.color && used.includes(color.name);
                return `<button type="button" class="mxd-offer__swatch${/meliert|heather|melange/i.test(color.name) ? ' mxd-offer__swatch--heather' : ''}" role="radio" aria-checked="${color.name === line.color}" aria-label="${escapeHtml(color.name)}" title="${escapeHtml(color.name)}" style="--swatch: ${escapeHtml(swatchOf(color))};" data-color="${escapeHtml(color.name)}"${!available || taken ? ' disabled' : ''}></button>`;
              }).join('')}
            </div>
          </div>` : ''}
          <div class="mxd-offer__line-part">
            <div class="mxd-offer__label">
              <span>Menge <b data-line-sum>${pieces(count)}</b></span>
              ${sizes.length < 2 ? '' : estimated
                ? '<button type="button" class="mxd-offer__link" data-mode="sizes">Größen angeben</button>'
                : '<button type="button" class="mxd-offer__link" data-mode="total">Nur Gesamtmenge</button>'}
            </div>
            ${estimated ? `
              <div class="mxd-offer__total-row">
                <span class="mxd-offer__size-name">Gesamt</span>
                ${stepper('total', line.total, `Gesamtmenge ${line.color}`)}
              </div>
              <p class="mxd-offer__spread" data-spread>${escapeHtml(spreadText(line.total, sizes))}</p>` : `
              <div class="mxd-offer__sizes">
                ${sizes.map(size => `<div class="mxd-offer__size"><span class="mxd-offer__size-name">${escapeHtml(size)}</span>${stepper(size, (line.sizes || {})[size] || 0, `${line.color} ${size}`)}</div>`).join('')}
              </div>`}
          </div>
        </div>`;
    };

    return {
      html: `
        <div class="mxd-offer__product">
          ${head(product.title)}
          ${specs.length ? `<p class="mxd-offer__specs">${specs.map(spec => `<span>${escapeHtml(spec)}</span>`).join(' · ')}</p>` : ''}
          <img src="${escapeHtml(imageOf(product, (lines()[0] || {}).color))}" alt="${escapeHtml(product.title)}" width="640" height="640">
        </div>
        <div class="mxd-offer__body">
          <div class="mxd-offer__lines" data-lines>${lines().map(lineHtml).join('')}</div>
          ${lines().length < product.colors.length ? `<button type="button" class="mxd-offer__add" data-add><span>${ICONS.plus}</span>Weitere Farbe</button>` : ''}
          ${product.min > 1 ? hint(`Mindestmenge für ${escapeHtml(product.title)}: ${product.min} Teile.`) : ''}
        </div>`,
      bind: screen => {
        const lineOf = element => lines()[Number(element.closest('[data-line]').dataset.line)];
        const rerender = () => {
          const scroll = stage.scrollTop;
          render(0);
          stage.scrollTop = scroll;
        };
        screen.querySelectorAll('[data-color]').forEach(button => button.addEventListener('click', () => {
          const line = lineOf(button);
          change(() => {
            line.color = button.dataset.color;
            const sizes = O.sizesFor(product, line.color);
            if (line.sizes) line.sizes = Object.fromEntries(Object.entries(line.sizes).filter(([size]) => sizes.includes(size)));
          });
          rerender();
        }));
        screen.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => {
          const line = lineOf(button);
          change(() => {
            if (button.dataset.mode === 'total') {
              line.total = O.countOf(product, line);
            } else {
              line.sizes = O.piecesOf(product, line);
              line.total = null;
            }
          });
          rerender();
        }));
        screen.querySelectorAll('[data-remove]').forEach(button => button.addEventListener('click', () => {
          const line = lineOf(button);
          change(s => {
            s.lines = s.lines.filter(entry => entry !== line);
          });
          rerender();
        }));
        const add = screen.querySelector('[data-add]');
        if (add) add.addEventListener('click', () => {
          const used = lines().map(line => line.color);
          const color = product.colors.find(entry => !used.includes(entry.name) && O.sizesFor(product, entry.name).length);
          if (!color) return;
          change(s => {
            s.lines.push({ product: id, color: color.name, sizes: {}, total: null });
          });
          rerender();
        });
        screen.querySelectorAll('[data-stepper]').forEach(box => {
          const input = box.querySelector('input');
          const apply = value => {
            const line = lineOf(box);
            const amount = Math.max(0, Math.min(9999, Math.round(Number(value) || 0)));
            change(() => {
              if (box.dataset.stepper === 'total') line.total = amount;
              else line.sizes = { ...(line.sizes || {}), [box.dataset.stepper]: amount };
            });
            if (document.activeElement !== input) input.value = amount > 0 ? amount : '';
            box.classList.toggle('has-value', amount > 0);
            const lineBox = box.closest('[data-line]');
            const count = O.countOf(product, line);
            lineBox.querySelector('[data-line-sum]').textContent = pieces(count);
            const spread = lineBox.querySelector('[data-spread]');
            if (spread) spread.textContent = spreadText(line.total, O.sizesFor(product, line.color));
          };
          box.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => apply((Number(input.value) || 0) + Number(button.dataset.step))));
          input.addEventListener('input', () => apply(input.value));
          input.addEventListener('focus', () => input.select());
        });
      },
      valid: () => {
        const count = productPieces(id);
        if (count < 1) return `Gib mindestens ein Teil für ${product.title} an.`;
        if (count < product.min) return `Für ${product.title} brauchen wir mindestens ${product.min} Teile.`;
        if (quoteNow().over) return tooMany();
        return true;
      }
    };
  };

  SCREENS.design = () => ({
    html: `${head('Hast du ein Motiv?')}
      <div class="mxd-offer__body">
        <div class="mxd-offer__choices" role="radiogroup" aria-label="Motiv">
          ${DESIGNS.map(entry => {
            const fee = entry.fee ? config.design[entry.fee] : 0;
            const side = fee > 0 ? `+ ${money(shown(fee))}` : entry.side || 'Gratis';
            const tags = entry.key === 'ready' ? '<span class="mxd-offer__tag">Am schnellsten</span>' : '';
            const divider = entry.key === 'studio' ? '<div class="mxd-offer__divider"><span>Oder lieber selbst?</span></div>' : '';
            return divider + choice({ value: entry.key, title: entry.title, text: entry.text, side, tags, checked: state.design === entry.key });
          }).join('')}
        </div>
        ${state.design === 'studio' && config.studioUrl ? `<div class="mxd-offer__actions"><a class="mxd-offer__button mxd-offer__button--highlight" href="${escapeHtml(config.studioUrl)}" target="_blank" rel="noopener">Studio öffnen ${ICONS.external}</a></div>` : ''}
      </div>`,
    bind: screen => screen.querySelectorAll('[data-value]').forEach(button => button.addEventListener('click', () => {
      change(s => {
        s.design = button.dataset.value;
      });
      if (state.design === 'studio') {
        render(0);
      } else {
        paintChoices(screen, [state.design]);
        setTimeout(() => go(1), 220);
      }
    })),
    valid: () => (state.design ? true : 'Sag uns kurz, wie es mit dem Motiv aussieht.')
  });

  // Free services such as the shop sit apart under the paid extras.
  SCREENS.extras = () => {
    const extraChoice = extra => choice({
      value: extra.id,
      title: extra.title,
      text: extra.text,
      role: 'checkbox',
      side: extraPrice(extra),
      checked: state.extras.includes(extra.id),
      tags: extraTag(extra, state.who),
      tone: extra.price ? '' : 'bloom'
    });
    const free = config.extras.filter(extra => !extra.price);
    return {
      html: `${head('Noch was dazu?')}
        <div class="mxd-offer__body">
          <div class="mxd-offer__choices" role="group" aria-label="Extras">
            ${config.extras.filter(extra => extra.price).map(extraChoice).join('')}
            ${free.length ? `<div class="mxd-offer__divider"><span>Optional dazu</span></div>${free.map(extraChoice).join('')}` : ''}
          </div>
        </div>`,
      bind: screen => screen.querySelectorAll('[data-value]').forEach(button => button.addEventListener('click', event => {
        const id = button.dataset.value;
        change(s => {
          s.extras = s.extras.includes(id) ? s.extras.filter(entry => entry !== id) : [...s.extras, id];
        });
        button.setAttribute('aria-checked', String(state.extras.includes(id)));
        if (state.extras.includes(id) && button.classList.contains('mxd-offer__choice--bloom')) confetti(button, event);
      })),
      valid: () => true,
      skip: () => !state.extras.length
    };
  };

  const deadlineHint = q => {
    const d = q.delivery;
    if (state.timing === 'open' || !d.deadline) return '';
    const date = O.formatDate(d.deadline.date);
    if (d.deadline.status === 'ok') return hint(`Zum ${date} schaffen wir das ganz entspannt.`, 'strong', ICONS.check);
    if (d.deadline.status === 'express') {
      return state.express
        ? hint(`Mit Express könnten wir den ${date} schaffen.`, 'strong', ICONS.check)
        : hint(`Zum ${date} wird es mit normaler Produktion knapp. Mit Express-Produktion klappt es.`, 'warn', ICONS.clock);
    }
    return hint(`Zum ${date} ist es sehr knapp. Schick uns die Anfrage trotzdem: Wir schauen persönlich, was möglich ist, und melden uns sofort.`, 'warn', ICONS.clock);
  };

  // A fixed date is at least two days ahead; earlier is not possible.
  const DATE_LEAD_DAYS = 2;
  const earliestDate = () => O.addDays(new Date(), DATE_LEAD_DAYS);
  // Months counted on from the one the earliest date falls in: the calendar opens there, as none before has a day left.
  const monthsFromEarliest = date => {
    const earliest = earliestDate();
    return (date.getFullYear() - earliest.getFullYear()) * 12 + date.getMonth() - earliest.getMonth();
  };
  const tooEarly = iso => {
    const date = O.parseDate(iso);
    return !date || date < earliestDate();
  };

  // The wished date as a month at a glance. Each day is tinted by what it takes: standard production makes it, only
  // express does, or it is very tight; days before the earliest date are out.
  const MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  const DAY_NAMES = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  const DAY_STATUS = { ok: 'Passt', express: 'Mit Express', tight: 'Sehr knapp' };
  const CALENDAR_MONTHS = 12;
  const calendar = view => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const year = view.getFullYear();
    const month = view.getMonth();
    const offset = (year - today.getFullYear()) * 12 + month - today.getMonth();
    const opening = monthsFromEarliest(view) <= 0;
    const length = new Date(year, month + 1, 0).getDate();
    const chosen = O.parseDate(state.date);
    const first = new Date(year, month, 1);
    const lead = (first.getDay() + 6) % 7;
    const earliest = earliestDate();
    // One day of the month takes the tab stop: the chosen one, else the earliest, else the first.
    const stop = chosen && chosen.getFullYear() === year && chosen.getMonth() === month ? state.date : O.isoDate(earliest > first ? earliest : first);
    const days = Array.from({ length }, (_, index) => {
      const date = new Date(year, month, index + 1);
      const iso = O.isoDate(date);
      const past = date < earliest;
      const deadline = past ? null : O.quote(config, { ...state, date: iso }, now).delivery.deadline;
      const status = deadline ? deadline.status : '';
      return `<button type="button" class="mxd-offer__day${status ? ` mxd-offer__day--${status}` : ''}${+date === +today ? ' is-today' : ''}" aria-pressed="${iso === state.date}" aria-label="${DAY_NAMES[date.getDay()]}, ${O.formatDate(date)}${status ? `: ${DAY_STATUS[status]}` : ''}" data-day="${iso}"${past ? ' disabled' : ''} tabindex="${iso === stop ? 0 : -1}">${index + 1}</button>`;
    });
    return `
      <div class="mxd-offer__calendar">
        <div class="mxd-offer__calendar-head">
          <button type="button" class="mxd-offer__calendar-step" data-month="-1" aria-label="Voriger Monat"${opening ? ' disabled' : ''}>${ICONS.arrow}</button>
          <strong aria-live="polite">${MONTHS[month]} ${year}</strong>
          <button type="button" class="mxd-offer__calendar-step" data-month="1" aria-label="Nächster Monat"${offset >= CALENDAR_MONTHS ? ' disabled' : ''}>${ICONS.arrow}</button>
        </div>
        <div class="mxd-offer__calendar-grid" role="group" aria-label="${MONTHS[month]} ${year}">
          ${['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(name => `<span class="mxd-offer__calendar-name" aria-hidden="true">${name}</span>`).join('')}
          ${'<span></span>'.repeat(lead)}${days.join('')}
        </div>
        ${quoteNow().pieces > 0 ? `<div class="mxd-offer__calendar-legend">${Object.entries(DAY_STATUS).filter(([status]) => status !== 'express' || config.express).map(([status, text]) => `<span class="mxd-offer__day--${status}">${text}</span>`).join('')}</div>` : ''}
      </div>`;
  };

  SCREENS.timing = () => {
    const q = quoteNow();
    const chosen = tooEarly(state.date) ? earliestDate() : O.parseDate(state.date);
    let view = new Date(chosen.getFullYear(), chosen.getMonth(), 1);
    return {
      html: `${head('Bis wann?')}
        <div class="mxd-offer__body mxd-offer__body--stack">
          <div class="mxd-offer__choices" role="radiogroup" aria-label="Termin" style="--offer-columns: 2;" data-timing>
            ${choice({ value: 'open', title: 'Kein fester Termin', text: 'Wir liefern so schnell wie möglich.', checked: state.timing === 'open', tags: '<span class="mxd-offer__tag">Empfohlen</span>' })}
            ${choice({ value: 'date', title: 'Zu einem Termin', text: 'Pünktlich zu deinem Wunschtag.', side: config.fixedDate ? `+ ${O.formatPercent(config.fixedDate.percent)}` : 'Gratis', checked: state.timing === 'date' })}
          </div>
          ${state.timing === 'date' ? `
            <div class="mxd-offer__group" data-calendar>${calendar(view)}</div>` : ''}
          <div data-deadline>${state.timing ? deadlineHint(q) : ''}</div>
          ${config.express ? `
            <div class="mxd-offer__divider"><span>Produktion</span></div>
            <div class="mxd-offer__group">
              <div class="mxd-offer__choices" role="radiogroup" aria-label="Produktion" data-speed>
                ${choice({ value: 'standard', title: 'Standard', text: `Ca. ${totalDays(q)} Werktage bis zur Lieferung.`, side: 'Inklusive', checked: !state.express })}
                ${choice({ value: 'express', title: 'Priority-Queue', text: expressSaving(q), side: `+ ${O.formatPercent(config.express.percent)}`, checked: state.express, tone: 'express', tags: EXPRESS_TAG })}
              </div>
            </div>` : ''}
        </div>`,
      bind: screen => {
        screen.querySelectorAll('[data-timing] [data-value]').forEach(button => button.addEventListener('click', () => {
          change(s => {
            s.timing = button.dataset.value;
            if (s.timing === 'open') s.date = '';
          });
          render(0);
          const day = stage.querySelector('[data-day][tabindex="0"]');
          if (day) day.focus({ preventScroll: true });
        }));
        // Standard or express, one of the two always on; turning express on plays the light across its tile.
        const paintSpeed = before => {
          screen.querySelectorAll('[data-speed] [data-value]').forEach(button => {
            button.setAttribute('aria-checked', String((button.dataset.value === 'express') === state.express));
          });
          const express = screen.querySelector('[data-speed] [data-value="express"]');
          if (express && state.express && !before) light(express);
        };
        screen.querySelectorAll('[data-speed] [data-value]').forEach(button => button.addEventListener('click', () => {
          const before = state.express;
          change(s => {
            s.express = button.dataset.value === 'express';
          });
          paintSpeed(before);
          screen.querySelector('[data-deadline]').innerHTML = state.timing ? deadlineHint(quoteNow()) : '';
        }));
        const box = screen.querySelector('[data-calendar]');
        if (!box) return;
        const paint = focus => {
          box.innerHTML = calendar(view);
          const day = focus && box.querySelector(`[data-day="${focus}"]`);
          if (day) day.focus();
        };
        const pick = iso => {
          const before = state.express;
          change(s => {
            s.date = iso;
            const { deadline } = quoteNow().delivery;
            if (deadline && deadline.status !== 'ok') s.express = true;
          });
          paintSpeed(before);
          screen.querySelector('[data-deadline]').innerHTML = deadlineHint(quoteNow());
          paint(iso);
        };
        box.addEventListener('click', event => {
          const day = event.target.closest('[data-day]');
          const step = event.target.closest('[data-month]');
          if (day) pick(day.dataset.day);
          if (step && !step.disabled) {
            view = new Date(view.getFullYear(), view.getMonth() + Number(step.dataset.month), 1);
            paint();
            const same = box.querySelector(`[data-month="${step.dataset.month}"]:not([disabled])`);
            if (same) same.focus();
          }
        });
        // Arrow keys walk the days and turn the month at its edges, like a native date picker.
        box.addEventListener('keydown', event => {
          const day = event.target.closest('[data-day]');
          const move = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
          if (!day || !move) return;
          event.preventDefault();
          const next = O.addDays(O.parseDate(day.dataset.day), move);
          const target = box.querySelector(`[data-day="${O.isoDate(next)}"]`);
          if (target) {
            if (!target.disabled) target.focus();
            return;
          }
          const months = (next.getFullYear() - new Date().getFullYear()) * 12 + next.getMonth() - new Date().getMonth();
          if (monthsFromEarliest(next) < 0 || months > CALENDAR_MONTHS) return;
          view = new Date(next.getFullYear(), next.getMonth(), 1);
          paint(O.isoDate(next));
        });
      },
      valid: () => {
        if (!state.timing) return 'Wähl aus, ob es einen festen Termin gibt.';
        if (state.timing === 'date' && !O.parseDate(state.date)) return 'Trag dein Wunschdatum ein.';
        if (state.timing === 'date' && tooEarly(state.date)) return `Ein fester Termin geht frühestens am ${O.formatDate(earliestDate())}.`;
        return true;
      }
    };
  };

  const contactFields = ({ note = true } = {}) => {
    const orgLabel = isBusiness() ? 'Firma' : 'Verein, Schule oder Institution';
    const c = state.contact;
    return `
      <div class="mxd-offer__fields">
        <div class="mxd-offer__field">
          <label for="offer-name">Name <span class="mxd-offer__required" aria-hidden="true">*</span></label>
          <input type="text" id="offer-name" autocomplete="name" required value="${escapeHtml(c.name)}" data-contact="name">
        </div>
        <div class="mxd-offer__field">
          <label for="offer-org">${orgLabel} <span class="mxd-offer__required" aria-hidden="true">*</span></label>
          <input type="text" id="offer-org" autocomplete="organization" value="${escapeHtml(c.org)}" data-contact="org" required>
        </div>
        <div class="mxd-offer__field">
          <label for="offer-email">E-Mail <span class="mxd-offer__required" aria-hidden="true">*</span></label>
          <input type="email" id="offer-email" autocomplete="email" required value="${escapeHtml(c.email)}" data-contact="email">
        </div>
        <div class="mxd-offer__field">
          <label for="offer-phone">Telefon <small>(optional, für schnelle Rückfragen)</small></label>
          <input type="tel" id="offer-phone" autocomplete="tel" value="${escapeHtml(c.phone)}" data-contact="phone">
        </div>
      </div>
      ${note ? `<p class="mxd-offer__note">${ICONS.lock}<span>Wir nutzen deine Angaben nur für dieses Angebot und mögliche Rückfragen dazu. Kein Newsletter, keine Werbung. Mehr in der <a href="${escapeHtml(config.privacyUrl)}" target="_blank" rel="noopener">Datenschutzerklärung</a>.</span></p>` : ''}`;
  };

  const legalLinks = () => (config.legal || []).map(link => `<a href="${escapeHtml(link.url)}" target="_blank" rel="noopener">${escapeHtml(link.title)}</a>`).join('');

  const bindContact = screen => screen.querySelectorAll('[data-contact]').forEach(input => {
    input.addEventListener('input', () => {
      state.contact[input.dataset.contact] = input.value;
      input.removeAttribute('aria-invalid');
      save();
      reseal();
    });
  });

  const contactProblem = screen => {
    const c = state.contact;
    const fail = (field, message) => {
      const input = screen && screen.querySelector(`[data-contact="${field}"]`);
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      return message;
    };
    if (!c.name.trim()) return fail('name', 'Wie heißt du?');
    if (!c.org.trim()) return fail('org', `Für wen ist das Angebot? Trag bitte ${isBusiness() ? 'die Firma' : 'den Verein oder die Einrichtung'} ein.`);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(c.email.trim())) return fail('email', 'Bitte gib eine gültige E-Mail-Adresse an.');
    return true;
  };

  SCREENS.contact = () => ({
    html: `${head('Fast fertig.')}
      <div class="mxd-offer__body">${contactFields()}</div>`,
    bind: bindContact,
    valid: () => contactProblem(stage.querySelector('.mxd-offer__screen')),
    // A short pause on the button, so the offer feels put together rather than flipped to.
    busy: 1400
  });

  // ---------------------------------------------------------------------------------------------------------------
  // The finished offer.

  const linkTo = (prefix, code) => `${location.origin}${location.pathname}#${prefix}=${code}`;
  const codeOf = options => O.encodeState({ ...state, total: quoteNow().gross }, options);
  const offerUrl = () => linkTo('o', codeOf());
  // The customer's link to share: the offer plus the contact details, sealed and kept current while they are typed,
  // so the link is at hand the moment it is shared.
  let sealedContact = '';
  let sealing = 0;
  const reseal = () => {
    const turn = ++sealing;
    if (!Object.values(state.contact).some(value => value.trim())) {
      sealedContact = '';
      return;
    }
    O.sealContact(state.contact).then(text => {
      if (turn === sealing) sealedContact = text;
    }, () => {});
  };
  const shareUrl = () => linkTo('o', O.joinShared(codeOf(), sealedContact));
  // For the shop only: the same order plus the contact details, opened as a production sheet.
  const orderUrl = () => linkTo('a', codeOf({ contact: true }));

  const sizesText = row => row.sizes.map(([size, n]) => `${n}x ${size}`).join(' / ');

  const rowsOf = q => [
    ...q.rows.map(row => ({
      step: `configure:${row.product}`,
      title: `${row.title} · ${row.color}`,
      info: `${sizesText(row)}${row.estimated ? ' (Geschätzt)' : ''}`,
      count: row.count,
      unit: row.unit,
      listUnit: row.listUnit !== row.unit ? row.listUnit : null,
      total: row.total
    })),
    // A free extra is a service, set up once the order is confirmed.
    ...q.extras.map(extra => ({ step: 'extras', title: extra.title, info: extra.perPiece ? 'pro Teil' : extra.total ? '' : 'Setup nach Auftragsbestätigung', count: extra.count, unit: extra.unit, total: extra.total })),
    // The artists' social levy is part of the design service's price, named in its line.
    ...(q.design ? [{
      step: 'design',
      title: `${q.design.title} (Pauschal)`,
      info: q.ksk ? `inkl. ${O.formatPercent(config.design.ksk)} Künstlersozialabgabe` : '',
      count: 1,
      unit: q.design.unit + (q.ksk ? q.ksk.total : 0),
      total: q.design.total + (q.ksk ? q.ksk.total : 0)
    }] : []),
    ...(q.express ? [{ step: 'timing', title: q.express.title, info: expressText(q), count: 1, unit: q.express.total, total: q.express.total }] : []),
    ...(q.fixedDate ? [{ step: 'timing', title: q.fixedDate.title, info: `Wunschtermin ${O.formatDate(q.delivery.deadline.date)}`, count: 1, unit: q.fixedDate.total, total: q.fixedDate.total }] : [])
  ];

  // Shipping sits with the totals rather than among the positions.
  const shippingOf = q => {
    if (q.shipping.pickup) return [pickupPlace ? `Abholung in ${pickupPlace}` : 'Abholung', 'Kostenlos'];
    const label = q.shipping.method ? `${q.shipping.method} (${q.tax.country.name})` : q.tax.country.name;
    return [label, priced(q.shipping.total)];
  };
  // Back from pickup to shipping, with what shipping would cost.
  const shipBack = () => {
    const cost = O.quote(config, { ...state, pickup: false }).shipping.total;
    return cost ? `Versenden (+${money(cost)})` : 'Versenden';
  };
  // The town of the studio, from the second line of the company address ("81543 München").
  const pickupPlace = String((config.company || {}).address || '').split('\n')[1]?.replace(/^\d+\s*/, '').trim() || '';

  const totalsOf = q => [
    shippingOf(q),
    ['Nettobetrag', money(q.net)],
    [q.tax.note ? taxSuffix(q) : `zzgl. ${O.formatPercent(q.tax.rate)} USt.`, money(q.vat)],
    ['Gesamt', money(q.gross), true]
  ];

  const INCLUDES = ['Druck vorne und hinten inklusive', 'Datei-Check und Druckvorschau', 'Keine Einrichtungskosten, alle Farben'];

  const nextStepsOf = q => [
    ['Angebot akzeptieren', 'Online mit einem Klick oder per QR-Code im PDF. Noch völlig unverbindlich bis zur Freigabe.'],
    ['Druckvorschau freigeben', config.texts.reply || 'Wir melden uns mit deiner digitalen Druckvorschau.'],
    ['Rechnung bezahlen', config.texts.payment || 'Zahlung nach Freigabe der Druckvorschau.'],
    ['Produktion und Versand', `Lieferung ca. ${q.delivery.days} Werktage nach Freigabe.`]
  ];

  const ensureNumber = () => {
    if (state.number) return;
    const random = () => (window.crypto && window.crypto.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32 : Math.random());
    state.number = O.offerNumber(new Date(), random);
    state.created = O.isoDate(new Date());
    save();
  };

  const validUntil = () => O.addDays(O.parseDate(state.created) || new Date(), config.validDays);

  SCREENS.offer = () => {
    ensureNumber();
    const q = quoteNow();
    const link = offerUrl();
    const code = O.qr(link, 'M');
    const notes = [];
    if (opened && opened.expired) notes.push(hint(`Das Angebot ${escapeHtml(opened.number)} war abgelaufen. Hier sind die aktuellen Preise unter neuer Nummer.`, 'warn'));
    else if (opened && opened.total !== null && opened.total !== q.gross) notes.push(hint('Die Preise haben sich seit dem Angebot geändert. Unten siehst du die aktuellen Preise.', 'warn'));
    if (q.over) notes.push(hint(tooMany(), 'warn'));
    if (q.delivery.deadline && !q.delivery.deadline.met) notes.push(hint(`Dein Wunschtermin ${O.formatDate(q.delivery.deadline.date)} ist sehr knapp. Wir prüfen das persönlich, sobald du das Angebot akzeptierst.`, 'warn', ICONS.clock));
    const contactKnown = contactProblem(null) === true;
    const c = state.contact;
    return {
      wide: true,
      offer: true,
      html: `
        <div class="mxd-offer__doc">
          <div>
            <h2 class="mxd-offer__title" tabindex="-1" data-offer-title>${c.org ? escapeHtml(c.org) : c.name ? `Für ${escapeHtml(c.name.split(' ')[0])}` : 'Alles geklärt.'}</h2>
            ${notes.join('')}
            <div class="mxd-offer__stats">
              <div class="mxd-offer__stat"><strong>${O.formatCount(q.pieces)}</strong><span>Teile</span></div>
              <div class="mxd-offer__stat"><strong>${money(q.perPiece)}</strong><span>pro Teil, alles inklusive</span></div>
              <div class="mxd-offer__stat"><strong>${WEEKDAYS[q.delivery.arrival.getDay()]} ${O.formatDate(q.delivery.arrival).slice(0, 6)}</strong><span>Wenn du bis ${O.formatDate(q.delivery.start).slice(0, 6)} freigibst</span></div>
            </div>
            ${q.savings > 0 ? hint(`Du sparst <strong>${money(q.savings)}</strong> mit dem Mengenrabatt`, 'strong', ICONS.tag) : ''}
            <table class="mxd-offer__table mxd-offer__table--editable">
              <thead><tr><th>Position</th><th>Menge</th><th class="is-unit">Einzelpreis</th><th>Gesamt</th></tr></thead>
              <tbody>
                ${rowsOf(q).map(row => `
                  <tr>
                    <td><button type="button" class="mxd-offer__row-edit" data-edit-step="${escapeHtml(row.step)}" aria-label="${escapeHtml(row.title)} ändern" title="Ändern">${ICONS.edit}</button>${escapeHtml(row.title)}${row.info ? `<small>${escapeHtml(row.info)}</small>` : ''}</td>
                    <td>${O.formatCount(row.count)}</td>
                    <td class="is-unit">${row.listUnit ? `<s>${money(row.listUnit)}</s>` : ''}${priced(row.unit)}</td>
                    <td>${priced(row.total)}</td>
                  </tr>`).join('')}
              </tbody>
              <tfoot>
                ${totalsOf(q).map(([label, value, strong], index) => `<tr${strong ? ' class="is-total"' : ''}><td colspan="2">${escapeHtml(label)}${index === 0 ? ` <button type="button" class="mxd-offer__link mxd-offer__pickup" data-pickup>${q.shipping.pickup ? shipBack() : 'Selbst abholen'}</button>` : ''}</td><td class="is-unit"></td><td>${value}</td></tr>`).join('')}
              </tfoot>
            </table>
            <ol class="mxd-offer__steps">${nextStepsOf(q).map(([title, text]) => `<li><div><strong>${escapeHtml(title)}</strong>${escapeHtml(text)}</div></li>`).join('')}</ol>
          </div>
          <aside class="mxd-offer__side">
            <div class="mxd-offer__side-head">
              <strong class="mxd-offer__side-total">${money(q.net)}</strong>
              <small>${taxNote(q)} · gültig bis ${O.formatDate(validUntil())}</small>
            </div>
            <div class="mxd-offer__accept" data-accept>
              ${contactKnown ? '' : contactFields({ note: false })}
              <button type="button" class="mxd-offer__button mxd-offer__button--highlight" data-accept-button>Angebot akzeptieren ${ICONS.sign}</button>
            </div>
            <div class="mxd-offer__side-row">
              <button type="button" class="mxd-offer__tool" data-pdf aria-label="PDF herunterladen">${ICONS.download} PDF</button>
              <button type="button" class="mxd-offer__tool" data-share aria-label="Link teilen">${ICONS.share} Teilen</button>
            </div>
            <div class="mxd-offer__qr">
              <svg viewBox="-2 -2 ${code.size + 4} ${code.size + 4}" role="img" aria-label="QR-Code zum Angebot" shape-rendering="crispEdges"><path d="${O.qrPath(code)}" fill="#000"/></svg>
              <span><strong class="mxd-offer__qr-desktop">Aufs Handy holen</strong><strong class="mxd-offer__qr-mobile">Mit anderen teilen</strong>QR-Code scannen, um dein Angebot zu öffnen, zu teilen oder zu akzeptieren.</span>
            </div>
            <ul class="mxd-offer__includes">${INCLUDES.map(item => `<li>${ICONS.check}<span>${escapeHtml(item)}</span></li>`).join('')}</ul>
          </aside>
          <div class="mxd-offer__doc-foot">
            <p class="mxd-offer__fine">Angebot ${escapeHtml(state.number)} vom ${O.formatDate(O.parseDate(state.created))}, gültig bis ${O.formatDate(validUntil())}. Lieferzeiten in Werktagen ab Freigabe der Druckvorschau.${config.texts.terms ? ` ${escapeHtml(config.texts.terms)}` : ''}</p>
            <p class="mxd-offer__legal">${legalLinks()}</p>
          </div>
        </div>`,
      bind: screen => {
        history.replaceState({ offerStep: 'offer' }, '', link.slice(link.indexOf('#')));
        bindContact(screen);
        reseal();
        screen.querySelector('[data-accept-button]').addEventListener('click', () => accept(screen));
        screen.querySelector('[data-pdf]').addEventListener('click', event => downloadPdf(event.currentTarget));
        screen.querySelector('[data-share]').addEventListener('click', () => share(shareUrl()));
        screen.querySelector('[data-pickup]').addEventListener('click', () => {
          opened = null;
          change(s => {
            s.pickup = !s.pickup;
          });
          const scroll = stage.scrollTop;
          render(0);
          stage.scrollTop = scroll;
        });
        // Each position leads straight back to the step it comes from.
        screen.querySelectorAll('[data-edit-step]').forEach(button => button.addEventListener('click', () => {
          opened = null;
          show(button.dataset.editStep, -1);
        }));
      },
      valid: () => true
    };
  };

  // After the shop received the acceptance: what happens now.
  const sentScreen = sent => {
    // The accepted offer stays at hand for its PDF and link, while the calculator itself starts afresh.
    const decoded = sent && sent.code ? O.decodeState(config, sent.code) : null;
    const accepted = decoded ? { ...fresh(), ...decoded, contact: { ...blankContact(), ...decoded.contact } } : null;
    const withAccepted = async action => {
      const before = state;
      state = accepted;
      try {
        await action();
      } finally {
        state = before;
      }
    };
    return {
      wide: false,
      offer: true,
      html: `${head('Danke! Wir legen los.')}
        <div class="mxd-offer__body">
          ${sent ? `<div class="mxd-offer__stats">
            <div class="mxd-offer__stat"><strong>${escapeHtml(sent.number)}</strong><span>Angebotsnummer</span></div>
            <div class="mxd-offer__stat"><strong>${escapeHtml(sent.sum)}</strong><span>${escapeHtml(sent.tax)}</span></div>
            <div class="mxd-offer__stat"><strong>${escapeHtml(sent.pieces)}</strong><span>Teile</span></div>
          </div>` : ''}
          ${accepted ? `<div class="mxd-offer__sent-tools">
            <button type="button" class="mxd-offer__tool" data-pdf aria-label="PDF herunterladen">${ICONS.download} PDF</button>
            <button type="button" class="mxd-offer__tool" data-share aria-label="Link teilen">${ICONS.share} Teilen</button>
          </div>` : ''}
          <ol class="mxd-offer__steps">
            <li><div><strong>Druckvorschau</strong>${escapeHtml(config.texts.reply || '')}</div></li>
            <li><div><strong>Freigabe und Zahlung</strong>${escapeHtml(config.texts.payment || '')}</div></li>
            <li><div><strong>Produktion und Versand</strong>Wir produzieren in München und schicken dir die Sendungsverfolgung.</div></li>
          </ol>
          ${config.sampleUrl ? `<div class="mxd-offer__actions"><a class="mxd-offer__button" href="${escapeHtml(config.sampleUrl)}">Muster bestellen ${ICONS.arrow}</a></div>` : ''}
        </div>`,
      bind: screen => {
        if (!accepted) return;
        screen.querySelector('[data-pdf]').addEventListener('click', event => withAccepted(() => downloadPdf(event.currentTarget)));
        screen.querySelector('[data-share]').addEventListener('click', () => withAccepted(() => share(sent.link)));
      },
      valid: () => true
    };
  };

  // The shop's view of an accepted offer: who, what, by when, without anything meant to sell it.
  const orderScreen = () => {
    const q = quoteNow();
    const c = state.contact;
    const design = DESIGNS.find(entry => entry.key === state.design);
    const extras = config.extras.filter(extra => state.extras.includes(extra.id)).map(extra => extra.title);
    const vatId = state.vatId && state.vatId !== '(angegeben)' ? state.vatId : '';
    const facts = [
      [isBusiness() ? 'Firma' : 'Organisation', c.org],
      ['Ansprechpartner', c.name],
      ['E-Mail', c.email && `<a href="mailto:${escapeHtml(c.email)}">${escapeHtml(c.email)}</a>`, true],
      ['Telefon', c.phone && `<a href="tel:${escapeHtml(c.phone.replace(/[^\d+]/g, ''))}">${escapeHtml(c.phone)}</a>`, true],
      ['USt-IdNr.', vatId],
      ['Kunde', audienceOf(state.who).title],
      ['Motiv', design ? design.title : ''],
      ['Extras', extras.join(', ') || 'Keine'],
      ['Lieferung', [q.tax.country.name, q.shipping.method].filter(Boolean).join(' · ')],
      ['Termin', `${q.delivery.deadline ? `Bis ${O.formatDate(q.delivery.deadline.date)}` : `Ca. ${q.delivery.days} Werktage nach Freigabe`}${state.express ? ' · Express' : ''}`],
      ['Summe', `${money(q.net)} netto · ${money(q.gross)} brutto`],
      ['Angebot', `${state.number} vom ${O.formatDate(O.parseDate(state.created))}, gültig bis ${O.formatDate(validUntil())}`]
    ].filter(([, value]) => value);
    return {
      wide: true,
      offer: true,
      html: `
        <div class="mxd-offer__order">
          <h2 class="mxd-offer__title" tabindex="-1" data-offer-title>Auftrag</h2>
          ${opened && opened.total !== null && opened.total !== q.gross ? hint(`Die Preise haben sich geändert. Bestätigt wurden ${money(opened.total)} brutto.`, 'warn') : ''}
          <dl class="mxd-offer__sheet">
            ${facts.map(([label, value, html]) => `<div><dt>${label}</dt><dd>${html ? value : escapeHtml(value)}</dd></div>`).join('')}
            ${c.message.trim() ? `<div class="is-wide"><dt>Nachricht</dt><dd>${escapeHtml(c.message.trim())}</dd></div>` : ''}
          </dl>
          <table class="mxd-offer__table">
            <thead><tr><th>Position</th><th>Menge</th></tr></thead>
            <tbody>
              ${q.rows.map(row => `<tr><td>${escapeHtml(`${row.title} · ${row.color}`)}<small>${escapeHtml(sizesText(row))}${row.estimated ? ' (Geschätzt)' : ''}</small></td><td>${O.formatCount(row.count)}</td></tr>`).join('')}
              ${q.extras.map(extra => `<tr><td>${escapeHtml(extra.title)}</td><td>${O.formatCount(extra.count)}</td></tr>`).join('')}
            </tbody>
            <tfoot><tr class="is-total"><td>Teile</td><td>${O.formatCount(q.pieces)}</td></tr></tfoot>
          </table>
          <div class="mxd-offer__actions">
            <button type="button" class="mxd-offer__button" data-print>Drucken</button>
            <a class="mxd-offer__button mxd-offer__button--ghost" href="${escapeHtml(offerUrl())}" target="_blank" rel="noopener">Kundenansicht</a>
          </div>
        </div>`,
      bind: screen => screen.querySelector('[data-print]').addEventListener('click', () => window.print()),
      valid: () => true
    };
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Accepting, sharing, PDF.

  const accept = screen => {
    const q = quoteNow();
    const problem = q.over ? tooMany() : contactProblem(screen);
    if (problem !== true) {
      toast(problem);
      shake(screen.querySelector('[data-accept]'));
      return;
    }
    if (!form) {
      toast('Das Bestätigen klappt gerade nicht. Schreib uns bitte direkt.');
      return;
    }
    const values = {
      name: state.contact.name.trim(),
      email: state.contact.email.trim(),
      phone: state.contact.phone.trim(),
      org: state.contact.org.trim(),
      number: state.number,
      sum: `${money(q.net)} ${taxSuffix(q, true)} (${money(q.gross)} brutto)`,
      link: orderUrl(),
      body: state.contact.message.trim()
    };
    Object.entries(values).forEach(([field, value]) => {
      const input = form.querySelector(`[data-field="${field}"]`);
      if (input) input.value = value;
    });
    try {
      sessionStorage.setItem(SENT_KEY, JSON.stringify({ number: state.number, sum: money(q.net), tax: taxSuffix(q, true), pieces: O.formatCount(q.pieces), link: shareUrl(), code: O.encodeState({ ...state, total: q.gross }, { contact: true }) }));
    } catch {}
    const button = screen.querySelector('[data-accept-button]');
    button.disabled = true;
    button.textContent = 'Wird gesendet …';
    form.submit();
  };

  const share = async link => {
    const title = `MIXEDOWN Angebot ${state.number}`;
    if (navigator.share) {
      try {
        await navigator.share({ title, url: link });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(link);
      toast(O.splitShared(link.split('#o=')[1] || '')[1] ? 'Link kopiert, mit deinen Kontaktdaten.' : 'Link kopiert.');
    } catch {
      window.prompt('Link zum Angebot', link);
    }
  };

  // The logo as a baseline JPEG for the PDF; null when there is none or it cannot be loaded.
  const logoJpeg = () => new Promise(resolve => {
    if (!config.logo) return resolve(null);
    const image = new Image();
    image.crossOrigin = 'anonymous';
    const timer = setTimeout(() => resolve(null), 5000);
    image.onload = () => {
      clearTimeout(timer);
      try {
        const scale = Math.min(1, 900 / image.naturalWidth);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(image.naturalWidth * scale);
        canvas.height = Math.round(image.naturalHeight * scale);
        const context = canvas.getContext('2d');
        context.fillStyle = '#fff';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const data = canvas.toDataURL('image/jpeg', 0.92);
        const binary = atob(data.split(',')[1]);
        resolve({ bytes: Uint8Array.from(binary, char => char.charCodeAt(0)), width: canvas.width, height: canvas.height });
      } catch {
        resolve(null);
      }
    };
    image.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    image.src = config.logo.startsWith('//') ? `https:${config.logo}` : config.logo;
  });

  const buildPdf = (q, logo) => {
    const c = state.contact;
    const link = offerUrl();
    const doc = O.createPdf({ title: `Angebot ${state.number}`, author: config.company.name || 'MIXEDOWN', subject: `Angebot für ${c.org || c.name}` });
    const L = 18;
    const R = 192;
    const BOTTOM = 268;
    const gray = '#666666';
    const company = config.company;
    let page = 0;

    const footer = () => {
      doc.line(L, 278, R, 278, { width: 0.2 });
      const columns = [
        [company.name, ...String(company.address || '').split('\n')],
        [company.email, company.phone, company.web].filter(Boolean),
        String(company.legal || '').split('\n')
      ];
      columns.forEach((lines, i) => lines.filter(Boolean).flatMap(text => doc.wrap(text, 50, 6.5))
        .forEach((text, j) => doc.text(text, L + i * 62, 282 + j * 3, { size: 6.5, color: gray })));
    };

    const header = () => {
      doc.addPage();
      page += 1;
      if (logo) {
        const h = 8;
        const w = Math.min(60, (logo.width / logo.height) * h);
        doc.jpeg(logo.bytes, logo.width, logo.height, L, 14, w, (w * logo.height) / logo.width);
      } else {
        doc.text('MIXEDOWN®', L, 21, { size: 22, bold: true, scale: 80 });
      }
      doc.text('ANGEBOT', R, 21, { size: 22, bold: true, scale: 80, align: 'right' });
      doc.line(L, 26, R, 26, { width: 0.6 });
      footer();
      return page === 1 ? 32 : 34;
    };

    const tableHead = y => {
      doc.text('Pos.', L, y, { size: 7.5, color: gray });
      doc.text('Beschreibung', L + 10, y, { size: 7.5, color: gray });
      doc.text('Menge', 132, y, { size: 7.5, color: gray, align: 'right' });
      doc.text('Einzelpreis', 162, y, { size: 7.5, color: gray, align: 'right' });
      doc.text('Gesamt', R, y, { size: 7.5, color: gray, align: 'right' });
      doc.line(L, y + 2, R, y + 2, { width: 0.4 });
      return y + 7;
    };

    let y = header();
    doc.text([company.name, ...String(company.address || '').split('\n')].filter(Boolean).join(' · '), L, y, { size: 7, color: gray });
    y += 8;

    // Recipient on the left, offer details on the right.
    const recipient = [c.org, c.name, c.email, c.phone, state.vatId && state.vatId !== '(angegeben)' ? `USt-IdNr. ${state.vatId}` : '', q.tax.country.name].filter(Boolean);
    recipient.forEach((text, i) => doc.text(text, L, y + i * 5, { size: i === 0 ? 11 : 9.5, bold: i === 0 }));
    const details = [
      ['Angebotsnummer', state.number],
      ['Datum', O.formatDate(O.parseDate(state.created))],
      ['Gültig bis', O.formatDate(validUntil())],
      ['Kunde', audienceOf(state.who).title],
      ['Lieferzeit', `ca. ${q.delivery.days} Werktage ab Freigabe`],
      ...(q.delivery.deadline ? [['Wunschtermin', O.formatDate(q.delivery.deadline.date)]] : [])
    ];
    details.forEach(([label, value], i) => {
      doc.text(label, 124, y + i * 5, { size: 8.5, color: gray });
      doc.text(value, R, y + i * 5, { size: 8.5, bold: i === 0, align: 'right' });
    });
    y += Math.max(recipient.length, details.length) * 5 + 8;

    doc.text(`Angebot ${state.number}`, L, y, { size: 18, bold: true, scale: 85 });
    y += 9;
    y = tableHead(y);

    rowsOf(q).forEach((row, index) => {
      const infoLines = row.info ? doc.wrap(row.info, 100, 8) : [];
      // From the row's first baseline to its last one: the info lines, or the struck list price under the unit price.
      const depth = Math.max(infoLines.length ? 4 + (infoLines.length - 1) * 3.8 : 0, row.listUnit ? 4 : 0);
      if (y + depth > BOTTOM) {
        y = tableHead(header());
      }
      doc.text(String(index + 1), L, y, { size: 9 });
      doc.text(row.title, L + 10, y, { size: 9.5, bold: true });
      infoLines.forEach((text, i) => doc.text(text, L + 10, y + 4 + i * 3.8, { size: 8, color: gray }));
      doc.text(O.formatCount(row.count), 132, y, { size: 9.5, align: 'right' });
      doc.text(priced(row.unit), 162, y, { size: 9.5, align: 'right' });
      if (row.listUnit) {
        const old = money(row.listUnit);
        const w = doc.text(old, 162, y + 4, { size: 7.5, color: '#999999', align: 'right' });
        doc.line(162 - w, y + 3.1, 162, y + 3.1, { width: 0.2, color: '#999999' });
      }
      doc.text(priced(row.total), R, y, { size: 9.5, align: 'right' });
      doc.line(L, y + depth + 2.6, R, y + depth + 2.6, { width: 0.1, color: '#cccccc' });
      y += depth + 8;
    });

    // The totals on the right, the QR code to accept beside them.
    const totals = totalsOf(q);
    const qrSize = 32;
    const caption = doc.wrap('Öffnet dein Angebot online: ansehen, teilen und mit einem Klick akzeptieren.', 54, 8);
    const labelsOf = totals.map(([label, , strong]) => (strong ? [label] : doc.wrap(label, 52, 9)));
    const totalsDepth = totals.reduce((sum, [, , strong], i) => sum + (strong ? 9 : 5.5 + (labelsOf[i].length - 1) * 4), 0) + (q.savings > 0 ? 6 : 0);
    if (y + 2 + Math.max(totalsDepth, qrSize) > BOTTOM) y = header();
    y += 2;
    const top = y - 4;
    const code = O.qr(link, 'M');
    doc.qrCode(code, L, top, qrSize);
    doc.link(L, top, qrSize, qrSize, link);
    doc.text('Scannen und akzeptieren', L + qrSize + 5, top + 4, { size: 9, bold: true });
    caption.forEach((text, i) => doc.text(text, L + qrSize + 5, top + 9 + i * 3.6, { size: 8, color: gray }));
    totals.forEach(([label, value, strong], i) => {
      if (strong) {
        doc.line(112, y - 4, R, y - 4, { width: 0.5 });
        doc.text(label, 112, y + 1, { size: 12, bold: true });
        doc.text(value, R, y + 1, { size: 12, bold: true, align: 'right' });
        y += 9;
      } else {
        doc.text(value, R, y, { size: 9, align: 'right' });
        labelsOf[i].forEach((text, j) => doc.text(text, 112, y + j * 4, { size: 9 }));
        y += 5.5 + (labelsOf[i].length - 1) * 4;
      }
    });
    if (q.savings > 0) {
      doc.text(`Mengenrabatt −${q.tier.percent} % eingerechnet: du sparst ${money(q.savings)}.`, R, y, { size: 8.5, bold: true, align: 'right' });
      y += 6;
    }
    y = Math.max(y, top + qrSize + 4) + 6;

    // What happens next, kept together on one page.
    const steps = nextStepsOf(q).map(([title, text]) => [title, doc.wrap(text, 150, 8)]);
    if (y + steps.reduce((sum, [, lines]) => sum + 5.4 + lines.length * 3.6, 5) - 5 > BOTTOM) y = header();
    doc.text('SO GEHT ES WEITER', L, y, { size: 9, bold: true, scale: 90 });
    y += 5;
    steps.forEach(([title, lines], i) => {
      doc.rect(L, y - 3, 4, 4, { fill: '#000000' });
      doc.text(String(i + 1), L + 2, y, { size: 7, bold: true, color: '#ffffff', align: 'center' });
      doc.text(title, L + 6, y, { size: 8.5, bold: true });
      y += 4;
      lines.forEach(lineText => {
        doc.text(lineText, L + 6, y, { size: 8, color: gray });
        y += 3.6;
      });
      y += 1.4;
    });
    y += 3;

    const fine = [config.texts.payment, `Angebot gültig bis ${O.formatDate(validUntil())}. ${config.texts.terms || ''}`].filter(Boolean).join(' ');
    const fineLines = doc.wrap(fine, R - L, 7);
    if (y + (fineLines.length - 1) * 3.2 > BOTTOM + 4) y = header();
    fineLines.forEach(text => {
      doc.text(text, L, y, { size: 7, color: gray });
      y += 3.2;
    });
    return doc.output();
  };

  const downloadPdf = async button => {
    button.disabled = true;
    try {
      const q = quoteNow();
      const bytes = buildPdf(q, await logoJpeg());
      const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `MIXEDOWN-Angebot-${state.number}.pdf`;
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error(error);
      toast('Das PDF konnte nicht erstellt werden. Versuch es bitte noch einmal.');
    } finally {
      button.disabled = false;
    }
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Rendering and moving between screens.

  const paintChoices = (screen, values) => screen.querySelectorAll('[role="radio"][data-value]').forEach(button => {
    button.setAttribute('aria-checked', String(values.includes(button.dataset.value)));
  });

  const screenFor = id => {
    if (id.startsWith('configure:')) return configure(id.slice('configure:'.length));
    return SCREENS[id]();
  };

  const resumable = () => Boolean(state.who && state.step && state.step !== 'who');

  const renderBar = () => {
    const steps = flow();
    const index = steps.indexOf(current);
    const total = steps.length - 1;
    // On the intro the one button picks a draft up again where it was left, or starts a new offer.
    startLabel.textContent = resumable() ? 'Weitermachen' : startText;
    const done = current === 'offer' || current === 'sent' || current === 'order';
    // One segment per step like in the preview, filled up to the step on screen.
    if (progress.children.length !== total) progress.innerHTML = '<span><span></span></span>'.repeat(total);
    const reached = done ? total : current === 'intro' || index < 0 ? 0 : index + 1;
    [...progress.children].forEach((segment, i) => segment.classList.toggle('is-done', i < reached));
  };

  // The steps along the dock's top edge while the sizes are picked: free shipping where the home rates turn free after
  // a paid one, then the volume discounts. Each step takes an equal stretch, the fill runs through them with the
  // pieces and every step reached lights up; free shipping gets a check, and a cross once the pieces run past its range.
  const discounts = config.tiers.filter(([, percent]) => percent > 0).map(([from, percent]) => ({ from, label: `${percent}% ab ${O.formatCount(from)}` }));
  const freeAt = config.shippingRates.findIndex((rate, index) => index > 0 && rate.price === 0 && config.shippingRates[index - 1].price > 0);
  const freeShipping = freeAt > 0 ? { from: config.shippingRates[freeAt - 1].upTo + 1, upTo: config.shippingRates[freeAt].upTo, label: 'Gratis Versand' } : null;
  const meter = document.createElement('div');
  meter.className = 'mxd-offer__meter';
  meter.hidden = true;
  dock.prepend(meter);
  const renderMeter = q => {
    const steps = [...(freeShipping && q.tax.country.code === config.home ? [freeShipping] : []), ...discounts].sort((a, b) => a.from - b.from);
    const visible = steps.length > 0 && current.startsWith('configure:');
    meter.hidden = !visible;
    dock.classList.toggle('has-meter', visible);
    if (!visible) return;
    const key = steps.map(step => step.label).join('|');
    if (meter.dataset.steps !== key) {
      meter.dataset.steps = key;
      meter.innerHTML = `<span class="mxd-offer__meter-fill"></span>${steps.map((step, index) => `<span class="mxd-offer__meter-step" style="left: ${((index + 1) / steps.length) * 100}%">${step.upTo ? `<i class="mxd-offer__meter-mark">${ICONS.check}${ICONS.cross}</i>` : ''}${step.label}</span>`).join('')}`;
    }
    const count = q.pieces;
    const passed = steps.filter(step => count >= step.from).length;
    const below = passed ? steps[passed - 1].from : 0;
    const part = passed < steps.length ? (count - below) / (steps[passed].from - below) : 0;
    meter.style.setProperty('--meter', String(Math.min(1, (passed + part) / steps.length)));
    [...meter.querySelectorAll('.mxd-offer__meter-step')].forEach((element, index) => {
      const over = Boolean(steps[index].upTo && count > steps[index].upTo);
      element.classList.toggle('is-reached', index < passed && !over);
      element.classList.toggle('is-over', over);
      element.classList.toggle('is-next', index === passed);
    });
  };

  // The live price per printed piece in the dock once there are pieces, with a note when there are too many; the
  // whole bill comes with the offer.
  const renderLive = () => {
    if (current === 'intro' || current === 'offer' || current === 'sent' || current === 'order') return;
    const q = quoteNow();
    renderMeter(q);
    if (!q.pieces) {
      live.innerHTML = '';
      return;
    }
    const nudge = q.over ? `Maximal ${O.formatCount(config.maxPieces)} Teile pro Angebot` : '';
    // While a product is set up its own piece price shows; elsewhere the average over the order, marked as one when
    // the products cost differently.
    const own = current.startsWith('configure:') ? q.rows.filter(row => row.product === current.slice('configure:'.length)) : [];
    const ownCount = own.reduce((sum, row) => sum + row.count, 0);
    const each = ownCount ? Math.round(own.reduce((sum, row) => sum + row.total, 0) / ownCount) : q.goodsPerPiece;
    const average = !ownCount && new Set(q.rows.map(row => row.unit)).size > 1;
    live.innerHTML = `
      <div class="mxd-offer__live-total">
        <strong>${money(each)}</strong><small>/ Teil${average ? ' im Schnitt' : ''}</small>
        ${q.tier.percent ? `<span class="mxd-offer__tag">−${q.tier.percent} %</span>` : ''}
        <span>inkl. Druck · ${taxNote(q)}</span>
      </div>
      ${nudge ? `<div class="mxd-offer__live-nudge">${nudge}</div>` : ''}`;
  };

  const refresh = () => {
    renderBar();
    renderLive();
    if (screenInfo) nextLabel.textContent = screenInfo.next ? screenInfo.next() : 'Weiter';
    nextButton.classList.toggle('mxd-offer__button--skip', Boolean(screenInfo && screenInfo.skip && screenInfo.skip()));
  };

  let screenInfo = null;

  // A screen's title stays on one line: a long one shrinks until it fits.
  const fitTitle = () => {
    const title = stage.querySelector(':is(.mxd-offer__screen, .mxd-offer__product) > [data-offer-title]');
    if (!title) return;
    title.style.fontSize = '';
    const room = title.clientWidth;
    if (title.scrollWidth > room) title.style.fontSize = `${Math.floor((parseFloat(window.getComputedStyle(title).fontSize) * room) / title.scrollWidth)}px`;
  };
  let fitting = 0;
  window.addEventListener('resize', () => {
    window.cancelAnimationFrame(fitting);
    fitting = window.requestAnimationFrame(fitTitle);
  });

  const render = direction => {
    const info = current === 'sent' ? sentScreen(readSent()) : current === 'order' ? orderScreen() : screenFor(current);
    screenInfo = info;
    const screen = document.createElement('section');
    screen.className = `mxd-offer__screen${info.wide ? ' mxd-offer__screen--wide' : ''}${direction < 0 ? ' is-back' : ''}`;
    if (direction === 0) screen.style.animation = 'none';
    screen.innerHTML = info.html;
    stage.replaceChildren(screen);
    if (direction !== 0) stage.scrollTop = 0;
    fitTitle();
    info.bind(screen);
    dock.hidden = Boolean(info.offer);
    refresh();
    if (direction !== 0) {
      const title = screen.querySelector('[data-offer-title]');
      if (title) title.focus({ preventScroll: true });
    }
  };

  const show = (id, direction = 1, { push = true } = {}) => {
    current = id;
    // A hint belongs to the screen it was raised on.
    clearTimeout(toast.timer);
    toastBox.classList.remove('is-visible');
    if (id !== 'offer' && location.hash.startsWith('#o=')) history.replaceState(history.state, '', location.pathname + location.search);
    if (push) history.pushState({ offerStep: id }, '');
    state.step = id;
    save();
    render(direction);
  };

  let busy = false;
  const setBusy = on => {
    busy = on;
    nextButton.disabled = on;
    // No way back while the offer is put together.
    backButton.hidden = on;
    nextButton.classList.toggle('is-busy', on);
  };

  const go = delta => {
    if (busy) return;
    const steps = flow();
    const index = steps.indexOf(current);
    if (delta > 0) {
      const ok = screenInfo ? screenInfo.valid() : true;
      if (ok !== true) {
        toast(ok);
        shake(nextButton);
        return;
      }
      const target = steps[Math.min(index + 1, steps.length - 1)];
      if (!screenInfo || !screenInfo.busy) {
        show(target, 1);
        return;
      }
      const from = current;
      setBusy(true);
      window.setTimeout(() => {
        setBusy(false);
        // The browser's back button still works while the button waits: then there is nothing to advance from.
        if (current === from) show(target, 1);
      }, screenInfo.busy);
    } else if (index <= 0) {
      showIntro();
    } else {
      show(steps[index - 1], -1);
    }
  };

  const showIntro = () => {
    const leaving = current !== 'intro';
    current = 'intro';
    if (leaving) save();
    if (location.hash.startsWith('#o=')) history.replaceState(history.state, '', location.pathname + location.search);
    stage.replaceChildren(intro);
    dock.hidden = true;
    refresh();
    if (reel) reel.play();
  };

  const readSent = () => {
    try {
      return JSON.parse(sessionStorage.getItem(SENT_KEY));
    } catch {
      return null;
    }
  };

  nextButton.addEventListener('click', () => go(1));
  backButton.addEventListener('click', () => go(-1));
  stage.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.target.tagName !== 'INPUT' || current === 'offer') return;
    event.preventDefault();
    go(1);
  });
  window.addEventListener('popstate', event => {
    const id = event.state && event.state.offerStep;
    if (!id || id === 'intro') {
      showIntro();
      return;
    }
    const steps = flow();
    if (!steps.includes(id)) return;
    const direction = steps.indexOf(id) < steps.indexOf(current) ? -1 : 1;
    show(id, direction, { push: false });
  });

  const reel = Reel.create(config, { shown: () => current === 'intro' });
  if (reel) {
    intro.prepend(reel.element);
    document.addEventListener('visibilitychange', () => reel.play());
  }

  const draft = load();
  startButton.addEventListener('click', () => {
    if (resumable()) {
      const steps = flow();
      show(steps.includes(state.step) ? state.step : 'who');
      return;
    }
    state = fresh();
    if (draft && draft.contact) state.contact = draft.contact;
    save();
    show('who');
  });
  startButton.disabled = false;

  // Where to start: after accepting, from a shared link, from a readable link, or at the intro.
  history.replaceState({ offerStep: 'intro' }, '');
  const asking = new URLSearchParams(location.search).has('item');
  const asked = asking ? O.queryState(config, location.search) : null;
  if (form && form.querySelector('[data-offer-posted]')) {
    current = 'sent';
    render(1);
    confetti(stage);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  } else if (location.hash.startsWith('#a=')) {
    const decoded = O.decodeState(config, location.hash.slice(3));
    if (decoded) {
      state = { ...fresh(), ...decoded, contact: { ...blankContact(), ...decoded.contact } };
      opened = { number: decoded.number, total: decoded.total, expired: false };
      current = 'order';
      render(1);
    } else {
      showIntro();
      toast('Der Auftragslink ist leider unvollständig.');
    }
  } else if (location.hash.startsWith('#o=')) {
    const [code, sealed] = O.splitShared(location.hash.slice(3));
    const decoded = O.decodeState(config, code);
    if (decoded) {
      const local = draft && draft.number === decoded.number ? draft : null;
      state = {
        ...fresh(),
        ...decoded,
        selected: [...new Set(decoded.lines.map(line => line.product))],
        timing: decoded.date ? 'date' : 'open',
        vatId: local ? local.vatId : decoded.vatId,
        contact: local ? local.contact : (draft ? draft.contact : blankContact())
      };
      const created = O.parseDate(decoded.created);
      const expired = !created || O.addDays(created, config.validDays) < O.addDays(new Date(), 0);
      opened = { number: decoded.number, total: decoded.total, expired };
      if (expired) {
        state.number = '';
        state.created = '';
      }
      current = 'offer';
      if (sealed) {
        // Contact details shared with the link fill the form; the address bar keeps the order only.
        history.replaceState(history.state, '', `${location.pathname}${location.search}#o=${code}`);
        O.openContact(sealed).then(contact => {
          if (contact) {
            state.contact = contact;
            save();
          }
          render(1);
        });
      } else {
        render(1);
      }
    } else {
      showIntro();
      toast('Der Link zum Angebot ist leider unvollständig.');
    }
  } else if (asking) {
    // A link put together by hand or by an agent: straight to the offer it describes. The link is read once, so a
    // reload keeps what was changed since.
    history.replaceState(history.state, '', location.pathname);
    if (asked) {
      state = {
        ...fresh(),
        ...asked,
        selected: [...new Set(asked.lines.map(line => line.product))],
        date: asked.date && !tooEarly(asked.date) ? asked.date : '',
        timing: asked.date && !tooEarly(asked.date) ? 'date' : 'open',
        contact: draft ? draft.contact : blankContact()
      };
      current = 'offer';
      render(1);
    } else {
      showIntro();
      toast('Der Link zum Angebot ist leider unvollständig.');
    }
  } else if (draft && draftInFlow()) {
    // Back after a reload or a closed tab: straight to the step the visit was on.
    state = draft;
    const steps = flow();
    show(steps.includes(draft.step) ? draft.step : 'who', 0);
  } else {
    if (draft) state = draft;
    showIntro();
  }
  if (form && form.querySelector('[data-offer-errors]')) toast('Das Bestätigen hat nicht geklappt. Bitte prüf deine E-Mail-Adresse und versuch es noch einmal.');

  const ready = document.fonts && document.fonts.ready ? Promise.race([document.fonts.ready, new Promise(done => setTimeout(done, 1500))]) : Promise.resolve();
  ready.then(() => {
    fitTitle();
    root.classList.remove('is-booting');
    root.classList.add('is-entering');
    setTimeout(() => root.classList.remove('is-entering'), 1200);
  });
})();
